// The first sentence, e.g. "Minified React error #520" without the "visit react.dev" tail.
const summarize = (message: string) => message.split(';')[0];

const getRootCause = (error: Error): unknown => {
  const seen = new Set<unknown>([error]);
  let cause = error.cause;
  while (cause instanceof Error && cause.cause !== undefined && !seen.has(cause.cause)) {
    seen.add(cause);
    cause = cause.cause;
  }
  return cause;
};

// React wraps some recoverable errors (e.g. #520) and keeps the error that actually threw in
// `cause`. Error Reporting only sees the reported error's message and stack, so report the
// root cause and keep the wrapper's summary for context.
const toReportableError = (error: unknown): Error | string => {
  if (typeof error === 'string') return error;
  if (!(error instanceof Error)) return new Error(String(error));

  const cause = getRootCause(error);
  if (cause === undefined) return error;

  if (cause instanceof Error) {
    const reportable = new Error(`${cause.message} (reported as: ${summarize(error.message)})`);
    reportable.name = cause.name;
    if (cause.stack) reportable.stack = cause.stack;
    return reportable;
  }

  const reportable = new Error(`${summarize(error.message)}, caused by: ${String(cause)}`);
  if (error.stack) reportable.stack = error.stack;
  return reportable;
};

export default toReportableError;
